import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-batch-cloning-summary',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './batch-cloning-summary.component.html',
  styleUrls: ['./batch-cloning-summary.component.css'],
})
export class BatchCloningSummaryComponent {
  @Input() singleCount = 0;
  @Input() myaCount = 0;
  @Input() expiringCount = 0;

  @Input() notifyEmail = true;
  @Input() notifySms = false;
  @Input() notifyInApp = true;
  @Input() notifySuperAdmin = false;
  @Input() notifyAdmins = false;

  @Output() notifyEmailChange = new EventEmitter<boolean>();
  @Output() notifySmsChange = new EventEmitter<boolean>();
  @Output() notifyInAppChange = new EventEmitter<boolean>();
  @Output() notifySuperAdminChange = new EventEmitter<boolean>();
  @Output() notifyAdminsChange = new EventEmitter<boolean>();
}